{ "id": "teleportation", "name": "Téléportation", "icon": "icons/spells/teleportation", "description": "Se téléporte de 220 px vers la visée.", "cooldown": 6, "effects": [ { "type": "blink", "distance": 220 } ] }
